export const EVENT_TITLE_LOGO_SIZE = {
    width: 24,
    height: 24,
};
//# sourceMappingURL=imageConfig.js.map